// JSA Basic Info
import { v4 as uuidv4 } from "uuid";

export class JsaBasicInfo {
  constructor(data = {}) {
    this.rowId = data.id || uuidv4();
    this.jsaClientName = data.jsa_client_name || "";
    this.supervisor = data.supervisor_id
      ? {
          value: data.supervisor_id,
          label: `${data.supervisor_id} - ${data.supervisor_name}`,
        }
      : {
          value: "",
          label: "",
        };
    this.jsaCompletedTime = data.jsa_completed_time || "";
    this.jsaCompletedDate = data.jsa_completed_date || "";
    this.jsaJobDescription = data.jsa_job_description || "";
    this.siteLocation = data.site_location
      ? {
          label: data.site_location,
          value: data?.place_id || "",
          lat: data?.lat || "",
          lng: data?.lng || "",
        }
      : null;
    this.medicalFacility = data.medical_facility || "";
    this.medicalFacilityAddress = data.medical_facility_address || "";
  }

  setJsaClientName(clientName) {
    this.jsaClientName = clientName;
  }

  setJsaJobDescription(jobDescription) {
    this.jsaJobDescription = jobDescription;
  }

  setSupervisor(supervisor) {
    this.supervisor = supervisor;
  }

  setJsaCompletedTime(time) {
    this.jsaCompletedTime = time;
  }

  setJsaCompletedDate(date) {
    if (!date) {
      this.jsaCompletedDate = null;
      return;
    }
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    this.jsaCompletedDate = `${year}-${month}-${day}`;
  }

  setSiteLocation(location) {
    this.siteLocation = location;
  }

  setMedicalFacility(facility) {
    this.medicalFacility = facility;
  }

  setMedicalFacilityFormattedAddress(address) {
    this.medicalFacilityAddress = address;
  }

  // To json for sending to the database
  toJson() {
    return {
      id: this.rowId,
      jsa_client_name: this.jsaClientName,
      supervisor_id: this.supervisor?.value || "",
      jsa_completed_time: this.jsaCompletedTime,
      jsa_completed_date: this.jsaCompletedDate,
      jsa_job_description: this.jsaJobDescription,
      site_location: this.siteLocation?.label || "",
      medical_facility: this.medicalFacility,
      medical_facility_address: this.medicalFacilityAddress,
    };
  }

  // Helper for single and multi-field patches to be sent via websocket
  toPatch(fields, action = "update") {
    const fieldMap = {
      jsaClientName: "jsa_client_name",
      supervisorId: "supervisor_id",
      jsaCompletedTime: "jsa_completed_time",
      jsaCompletedDate: "jsa_completed_date",
      jsaJobDescription: "jsa_job_description",
      siteLocation: "site_location",
      medicalFacility: "medical_facility",
      medicalFacilityAddress: "medical_facility_address",
    };

    const patch = {
      patch_type: "jsa_basic_info",
      jsa_id: this.rowId,
      action,
    };

    for (const [key, value] of Object.entries(fields)) {
      const dbField = fieldMap[key];
      if (dbField) {
        // Check siteLocation FIRST - extract the label (address), not the Place ID
        if (value && typeof value === "object" && key === "siteLocation") {
          patch[dbField] = value.label || "";
        } else if (value && typeof value === "object" && "value" in value) {
          // Smart extraction: if value is object with .value (like supervisor), use the value
          patch[dbField] = value.value;
        } else {
          patch[dbField] = value;
        }
      }
    }

    return patch;
  }
}
